import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/ui/toaster";
import { ToastContainer } from "react-toastify";
import Auth from "@/features/authentication/providers/auth-provider";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { refetchOnWindowFocus: false },
  },
});

export default function Providers({
  children,
}: {
  readonly children: React.ReactNode;
}) {
  const { lng = "ar" } = useParams<{ lng: string }>();

  useEffect(() => {
    i18n.changeLanguage(lng);
  }, [lng]);

  return (
    <QueryClientProvider client={queryClient}>
      <I18nextProvider i18n={i18n}>
        <Auth locale={lng}>
          {children}
          <ToastContainer
            position="bottom-right"
            hideProgressBar={true}
            rtl={lng === "ar"}
          />
          <Toaster />
        </Auth>
      </I18nextProvider>
    </QueryClientProvider>
  );
}
